import script from "./Test.vue?vue&type=script&setup=true&lang=js"
export * from "./Test.vue?vue&type=script&setup=true&lang=js"

import "./Test.vue?vue&type=style&index=0&id=252d02c5&lang=scss&scoped=true"

import exportComponent from "D:\\Git\\monetwareProjects\\kunqu-opera-test\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-252d02c5"]])

export default __exports__